export const defaultZoomControllerButtonAvailability = {
    zoomIn: false,
    zoomOut: false,
    resetZoom: false,
    panUp: false,
    panDown: false,
    panLeft: false,
    panRight: false
};
//# sourceMappingURL=button-availability.js.map